module.exports = __webpack_public_path__ + "static/media/autoImmune-invoice-sample.7f2c0065.svg";